import PropTypes from 'prop-types';

import BriefPage from '@views/Brief/BriefPage';

const BriefWindow = ({ sequence }) => {
  return <BriefPage {...sequence} isModal={true} total={sequence?.total || 0} />;
};

BriefWindow.propTypes = {
  sequence: PropTypes.object,
};

export default BriefWindow;
